<template>
  <div id="app">
    <v-app id="inspire">
      <!-- Tutorial Stuff -->

      <v-overlay
        v-if="overlay"
        :z-index="8"
        :value="removeOverlay"
        opacity="0.80"
      >
        <v-container>
          <v-layout align-center>
            <v-col class="text-center overlay_code_activation">
              <p>
                Asegurate de tener el codigo de activación a la mano (viene en
                el empaque).
              </p>
            </v-col>
          </v-layout>
        </v-container>
      </v-overlay>
      <!-- Tutorial Stuff -->
      <v-content class="linkpet">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4s>
              <v-card class="elevation-12 showcode">
                <v-col cols="12">
                  <v-row justify="center" align="center" class="mb-4">
                    <v-col justify="center" align="center">
                      <v-col sm="12" md="6" v-if="formActivate">
                        <!-- Tutorial Stuff -->
                        <v-img
                          v-if="overlay"
                          :src="require('@/assets/img/tutorial/up-arrow.svg')"
                          class="arrow-up"
                          alt=""
                        />
                        <v-img
                          v-if="overlay"
                          :src="
                            require('@/assets/img/tutorial/right-drawn-arrow.svg')
                          "
                          class="arrow"
                          alt=""
                        />
                        <!-- Tutorial Stuff -->
                        <p style="color:#fff; z-index:8;">
                          No olvides poner mayusculas y minusculas
                        </p>
                        <form>
                          <form-wrapper :validator="$v.form">
                            <div style="margin-bottom: 20px">
                              <form-summary />
                            </div>

                            <form-group name="codeActivate">
                              <template slot-scope="{ attrs }">
                                <v-text-field
                                  style="z-index:8;"
                                  solo-inverted
                                  outlined
                                  dark
                                  v-bind="attrs"
                                  append-icon="mdi-qrcode-plus"
                                  v-model="form.codeActivate"
                                  hint="12 caracteres requeridos"
                                  label="Codigo de activación"
                                  @input="$v.form.codeActivate.$touch()"
                                />
                              </template>
                            </form-group>
                          </form-wrapper>
                        </form>
                        <v-btn
                          color="#9ccc3c"
                          @click.prevent="activeCode"
                          :disabled="this.$v.$invalid"
                          style="color:#fff; text-transform:none;"
                          >Activar</v-btn
                        >
                      </v-col>
                      <div v-if="scanCode">
                        <div>
                          <h2 class="mb-5 mt-5" style="color:#F57C00;">
                            ¡Escanea el código del collar aquí!
                          </h2>
                        </div>
                        <QrcodeStream
                          style="width: 50%;"
                          @decode="onDecode"
                        ></QrcodeStream>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
              <v-col>
                <v-row justify="center" class="text-center">
                  <v-btn
                    to="/dashboard/usuario"
                    color="red lighten-1"
                    style="text-transform:none; color:#fff;"
                  >
                    Cancelar
                  </v-btn>
                </v-row>
              </v-col>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-snackbar top v-model="snackbar">
        {{ snackbarText }}
        <v-btn
          style="text-transform:none;"
          color="pink"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>
<!--suppress ES6CheckImport -->
<script>
import { mapActions } from "vuex";
import { QrcodeStream } from "vue-qrcode-reader";
import { maxLength } from "vuelidate/lib/validators";
export default {
  components: {
    QrcodeStream,
  },
  mounted() {
    if (this.$store.state.auth.seconddotone) {
      this.overlay = true;
    } else {
      this.overlay = false;
    }
  },
  data() {
    return {
      zIndex: 1,
      overlay: false,
      scanCode: false,
      snackbar: false,
      snackbarText: "",
      formActivate: true,
      form: {
        codeActivate: "",
      },
    };
  },
  validations: {
    form: {
      codeActivate: { maxLength: maxLength(12) },
    },
  },
  methods: {
    ...mapActions("pets", { petCodes: "petCodes" }),
    ...mapActions("pets", {
      setCodePet: "setCodePet",
      getPetCode: "getPetCode",
    }),
    activeCode() {
      this.scanCode = true;
      this.showCamera = true;
      this.formActivate = false;
    },
    onDecode(decodedString) {
      const petCode = this.getPetCodeFromURL(decodedString);
      const petId = this.$route.params.id_pet;
      this.getPetCode({ petCode })
        .then((res) => {
          const idPetCode = res.id;
          const petCodeActivator = res.codeActivation;
          if (res.pet !== null) {
            throw "Código QR ya se encuentra en uso";
          }
          if (this.form.codeActivate === petCodeActivator) {
            // Verifica que el código del qr no tenga una mascota asociada
            this.assignPetCode({ idPetCode, petId });
          } else if (this.form.codeActivate.length < 12) {
            this.snackbar = true;
            this.snackbarText = "Ingresa bien los digitos";
            this.scanCode = false;
            this.formActivate = true;
            this.form.codeActivate = "";
          } else if (this.form.codeActivate !== petCodeActivator) {
            this.snackbar = true;
            this.snackbarText =
              "El código de activación no coincide con la placa";
            this.scanCode = false;
            this.formActivate = true;
            this.form.codeActivate = "";
          } else {
            this.snackbar = true;
            this.snackbarText = "Código de activación erroneo";
            this.scanCode = false;
            this.formActivate = true;
            this.form.codeActivate = "";
          }
        })
        .catch((err) => {
          this.snackbar = true;
          this.scanCode = false;
          this.formActivate = true;
          this.form.codeActivate = "";
          if (err.response) {
            this.snackbarText = err.response.data;
          } else {
            this.snackbarText = err;
          }
        });
    },
    assignPetCode({ idPetCode, petId }) {
      this.showCamera = false;
      this.setCodePet({ idPetCode, petId })
        .then(() => {
          this.$router.push({
            name: "userDash",
          });
          // eslint-disable-next-line no-unused-vars
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarText = err.response.data;
        });
    },
    getPetCodeFromURL(url) {
      const urlObj = new URL(url);
      const urlParams = new URLSearchParams(urlObj.search);
      return urlParams.get("chaws");
    },
    getPetCodeActivatorFromURL(url) {
      const urlObj = new URL(url);
      const urlParams = new URLSearchParams(urlObj.search);
      return urlParams.get("inoshanda");
    },
    returnStatus(stat) {
      if (!stat) {
        this.overlay = false;
      }
    },
  },
  computed: {
    removeOverlay() {
      let stat = true;
      if (this.form.codeActivate != "") {
        stat = false;
        this.returnStatus(stat);
      }
      return stat;
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay_code_activation {
  margin-top: 550px;
  top: 50%;
  p {
    font-size: 20px;
  }
  @media only screen and (min-width: 1200px) {
    p {
      font-size: 28px;
    }
  }
}
.arrow-up {
  position: absolute;
  z-index: 8;
  right: 25%;
  bottom: -90px;
  height: 180px;
  width: 180px;
  @media only screen and (min-width: 1200px) {
    display: none;
  }
}
.arrow {
  display: none;
  @media only screen and (min-width: 1200px) {
    margin-top: 35px;
    display: block;
    position: absolute;
    z-index: 8;
    right: 75%;
    height: 250px;
    width: 250px;
  }
}
.linkpet {
  background-image: url("../../assets/img/backgrounds/fondoblanco.png");
  background-size: cover;
}
.showcode {
  background-image: url("../../assets/img/backgrounds/fondoazul.png");
  background-size: cover;
}
</style>
